import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {JwtParserService} from './services/jwt-parser.service';
import {ModalService} from './services/modal.service';
import {AuthGuard} from './services/auth.guard';
import {RouterModule} from '@angular/router';
import {ModalModule} from 'ngx-bootstrap/modal';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TrimStr} from './pipes/trim.pipe';
import {MaskCardPipe} from './pipes/mask-card.pipe';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ApiInterceptor} from './services/interceptor/api.interceptor';
import {VarDirective} from './directives/ng-var.directive';
import {TrapFocusDirective} from './directives/trap-focus.directive';
import {UcaNavigationComponent} from './components/uca-navigation/uca-navigation.component';
import {FormatBannerPipe} from './pipes/format-banner.pipe';
import {TooltipModalComponent} from './components/tooltip-modal/tooltip-modal.component';
import {FreshpassTitleComponent} from './components/freshpass-title/freshpass-title.component';
import {TermsAndConditionsComponent} from './components/terms-and-conditions/terms-and-conditions.component';
import {TermsContentComponent} from './components/terms-content/terms-content.component';
import {SavingsSummaryModalComponent} from './components/savings-summary-modal/savings-summary-modal.component';
import {PersonalizedSavingsComponent} from './components/personalized-savings/personalized-savings.component';
import {DomSanitizerPipe} from "./pipes/dom-sanitizer.pipe";
import {NotificationModalComponent} from './components/notification-modal/notification-modal.component';
import {FreshpassFaqComponent} from './components/freshpass-faq/freshpass-faq.component';
import {ImagePreloadService} from './services/image-preload.service';
import { SubscriptionService } from './services/subscription.service';
import { PartnerscardComponent } from './components/partnerscard/partnerscard.component';
import { PartnerscarouselComponent } from './components/partnerscarousel/partnerscarousel.component';
import { PlanCardComponent } from './components/plan-card/plan-card.component';
import { CustomerDetailsHeaderV2Component } from './components/customer-details-header-v2/customer-details-header-v2.component';

@NgModule({
    declarations: [
        TrimStr,
        VarDirective,
        TrapFocusDirective,
        MaskCardPipe,
        DomSanitizerPipe,
        UcaNavigationComponent,
        FormatBannerPipe,
        TooltipModalComponent,
        FreshpassTitleComponent,
        TermsAndConditionsComponent,
        TermsContentComponent,
        SavingsSummaryModalComponent,
        PersonalizedSavingsComponent,
        NotificationModalComponent,
        FreshpassFaqComponent,
        PartnerscardComponent,
        PartnerscarouselComponent,
        PlanCardComponent,
        CustomerDetailsHeaderV2Component
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule.forRoot()
    ],
    exports: [
        TrimStr,
        MaskCardPipe,
        DomSanitizerPipe,
        TrapFocusDirective,
        UcaNavigationComponent,
        TooltipModalComponent,
        FormatBannerPipe,
        FreshpassTitleComponent,
        TermsAndConditionsComponent,
        PersonalizedSavingsComponent,
        NotificationModalComponent,
        FreshpassFaqComponent,
        PartnerscardComponent,
        PartnerscarouselComponent,
        PlanCardComponent,
        CustomerDetailsHeaderV2Component
    ],
    providers: [JwtParserService, AuthGuard, {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiInterceptor,
        multi: true
    },
        ModalService,
        ImagePreloadService,
        SubscriptionService],
    schemas: [NO_ERRORS_SCHEMA] // required for svg custom properties
})
export class SharedModule {
}
